import { createContext } from 'react';
import type { FieldMetadataById } from 'state/common-form/metaData/fields/fields.model';

export const FieldMetadataContext = createContext<FieldMetadataById>({});
